import { FIELD_CLASS, LABEL_CLASS } from "./shared";

// Availability text, seasoning flag, vehicle/variant descriptors, care note, and intro copy.
export const ProductMetaSection = ({ config, form, handleField }) => (
  <>
    <p data-testid="admin-instock-managed-note" className="text-white/40 text-xs -mt-1">
      "In Stock (allow Buy Now)" and "Badge" (image overlay label) are managed from the {config.label} list page — set them there.
    </p>
    <label className="block">
      <span className={LABEL_CLASS}>Availability text</span>
      <input data-testid="admin-field-availability" value={form.availability} onChange={(e) => handleField("availability", e.target.value)} className={FIELD_CLASS} placeholder="e.g. In stock, ships in 3-5 days" />
    </label>
    {config.hasSeasoning && (
      <label className="flex items-center gap-2 text-white/80 text-sm">
        <input data-testid="admin-field-seasoning-required" type="checkbox" checked={form.seasoningRequired} onChange={(e) => handleField("seasoningRequired", e.target.checked)} />
        Requires canvas seasoning before first use
      </label>
    )}
    {(config.hasVehicle || config.hasVariants) && (
      <div className="grid grid-cols-2 gap-4">
        {config.hasVehicle && (
          <label className="block">
            <span className={LABEL_CLASS}>Vehicle fit key</span>
            <input data-testid="admin-field-vehicle" value={form.vehicle} onChange={(e) => handleField("vehicle", e.target.value)} className={FIELD_CLASS} placeholder="e.g. hilux, lc300, ranger" />
          </label>
        )}
        {config.hasVariants && (
          <label className="block">
            <span className={LABEL_CLASS}>Fitment/config descriptor</span>
            <input data-testid="admin-field-variants" value={form.variants} onChange={(e) => handleField("variants", e.target.value)} className={FIELD_CLASS} placeholder="e.g. Ranger · Hilux · Hard Lid · Canopy Mount" />
          </label>
        )}
      </div>
    )}
    {config.hasCareNote && (
      <label className="block">
        <span className={LABEL_CLASS}>Care/warranty note (optional)</span>
        <input data-testid="admin-field-care-note" value={form.careNote} onChange={(e) => handleField("careNote", e.target.value)} className={FIELD_CLASS} placeholder="e.g. Wind damage is not covered under warranty" />
      </label>
    )}
    <label className="block">
      <span className={LABEL_CLASS}>Intro / Description</span>
      <textarea data-testid="admin-field-intro" rows={4} value={form.intro} onChange={(e) => handleField("intro", e.target.value)} className={FIELD_CLASS} />
    </label>
  </>
);
